import * as yup from 'yup';

export const CreateClassFormValidation = yup.object().shape({
    description: yup.string().required('Nome da turma é obrigatório'),
    idCourse: yup.string().required('Curso é obrigatório'),
    idFaculty: yup.string().required('Unidade orgânica é obrigatório'),
    idDepartament: yup.string().required('Departamento é obrigatório'),
    level: yup.number().required('Ano é obrigatório').min(1, 'O ano deve ser maior que 0'),
    semester: yup.number().required('Semestre é obrigatório').min(1, 'O semestre deve ser 1 ou 2').max(2, 'O semestre deve ser 1 ou 2')    ,
    useOwnRulesForAcademicPeriod: yup.boolean().default(false).required('Definir se usar regras próprias para o período acadêmico é obrigatório'),
    start: yup.string()
        .when('useOwnRulesForAcademicPeriod', {
          is: true,
          then: schema => schema.required("Campo obrigatório"),
          otherwise: schema => schema.nullable().optional()
        }),
    end: yup.string()
        .when('useOwnRulesForAcademicPeriod', {
          is: true,
          then: schema => schema.required("Campo obrigatório"),
          otherwise: schema => schema.nullable().optional()
        })
});